export default "__VITE_ASSET__$zeJ_L$u__"